
interface Point {
  x: number;
  y: number;
}

export const polarToCartesian = (centerX: number, centerY: number, radius: number, angleInDegrees: number): Point => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};

export const createArcPath = (center: Point, startAngle: number, endAngle: number, radius: number): string => {
  const start = polarToCartesian(center.x, center.y, radius, startAngle);
  const end = polarToCartesian(center.x, center.y, radius, endAngle);
  const largeArc = endAngle - startAngle <= 180 ? "0" : "1";
  
  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArc} 1 ${end.x} ${end.y}`;
};

export const getDayAngle = (day: number): number => ((day - 1) * (360 / 28));

export const getMiddleAngle = (start: number, end: number): number => {
  const span = end - start + 1;
  return getDayAngle(start + span/2 - 0.5);
};
